import React from "react";
import { 
  Box, Typography, Stack, Avatar, IconButton, Menu, MenuItem, 
  Dialog, DialogTitle, DialogContent, DialogActions, Button, 
  TextField, Snackbar 
} from "@mui/material";
import { AccountCircle, ForkLeft } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import ReportIcon from '@mui/icons-material/Report';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate } from "react-router";
import YouTubeHoverPreview from "./YouTubeHoverPreview";
import FavoriteIcon from '@mui/icons-material/Favorite';
import ToggleButton from '@mui/material/ToggleButton';
import {useApiManager} from "lib/ApiContext";


const VideoBox = ({ loggedIn, publicationID, publishType, creador, video, title, description, likes, comments, width, height, navigateTo, setShowLogin }) => {
  const navigate = useNavigate();
  const contRef = React.useRef(null);
  const api = useApiManager();
  const [dynamicBoxWidth, setDynamicBoxWidth] = React.useState(width);
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [CData, setCData] = React.useState(null);
  const [likesCount, setLikeCounts] = React.useState(likes);
  const [LogoURL, setLogoURL] = React.useState(null);
  
  // Estados para el menú de opciones
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const [snackbar, setSnackbar] = React.useState({ open: false, message: "" });
 
  if (publishType == 0){
    height = "auto";  
  }
  console.log(creador);
  
  React.useEffect(() => {
    const container = contRef.current;
    if (container) {
      const containerPadding = 32;
      const newWidth = (container.clientWidth - containerPadding) ;

      setDynamicBoxWidth(newWidth);
    }
  }, [contRef.current, dynamicBoxWidth]);

  const fetchData = async () =>{
    if (creador != undefined && api) {
      const Data = await api.GetCreator(creador);
      setCData(Data);
      const LogoURLData = await api.GetImageURL(Data.Logo);
      setLogoURL(LogoURLData.url);
      const likedData = await api.GetPublicationLike(publicationID);
      if (likedData) setIsFavorite(likedData.liked);
    }
  };

  React.useEffect(() => {
    fetchData();
  },[creador, loggedIn]);

  // Handlers para el menú
  const handleMenuOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleReport = async () => {
    if (!reason.trim()) {
      setSnackbar({ open: true, message: "Por favor, ingresa un motivo" });
      return;
    }
    
    if (!api.session) {
      setShowLogin(true);
      setOpenDialog(false);
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/publications/${publicationID}/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          PublicationID: publicationID, 
          UserID: api.session.userID, 
          Reason: reason 
        })
      });
      const data = await res.json();
      
      if (res.ok) {
        setSnackbar({ open: true, message: data.message || "Reporte enviado exitosamente" });
      } else {
        setSnackbar({ open: true, message: data.message || "Ya habías reportado esta publicación" });
      }
      
      setOpenDialog(false);
      setReason("");
    } catch (error) {
      setSnackbar({ open: true, message: "Error al enviar el reporte" });
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(`https://overpower.tv/publication/${publicationID}`);
      setSnackbar({ open: true, message: "Link copiado al portapapeles" });
    } catch (error) {
      setSnackbar({ open: true, message: "Error al copiar el link" });
    }
    handleMenuClose();
  };

  const handleOpenReportDialog = () => {
    if (!api.session) {
      setShowLogin(true);
      handleMenuClose();
      return;
    }
    setOpenDialog(true);
    handleMenuClose();
  };

  return (
    <>
      <Box
        onClick={() => navigate(navigateTo)}
        sx={{
          width: {xs: 'calc(100% - 32px)', sm: 630, md: 630},
          maxWidth: 630,
          height: 'auto',
          margin: {xs: '16px', sm: 5},
          backgroundColor: "#14141F",
          borderRadius: "10px",
          border: "1px solid transparent",
          backgroundOrigin: "border-box",
          backgroundClip: "content-box, border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: "1px",
          cursor: "pointer",
          transition: "transform 0.3s, box-shadow 0.3s",
          "&:hover": {
            border: "1px solid rgba(199,125,255,.4)",
            boxShadow: "0 0 12px rgba(157,0,255,.4)",
            backgroundColor: "#1E1B2E",
          },
        }}
      >
        <Stack ref={contRef} spacing={0}
          padding={0}
          direction="column"
          width="100%"
          alignItems="stretch">
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
              margin: 2
            }}
          >
            <Avatar sx={{ bgcolor: "#9D00FF", width: 34, height: 34 }}
              src={LogoURL}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/creators/${CData?.Nickname}`);
              }}
              role="button"
              tabIndex={0}
            >
              {CData?.Name.charAt(0).toUpperCase() || "?"}
            </Avatar>
            <Typography
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/creators/${CData?.Nickname}`);
              }}
              role="button"
              tabIndex={0}
            >
              {CData?.Name}
            </Typography>
          </Stack>

          {/* Video Preview */}
          <Box sx={{ flexShrink: 0, marginTop: 0, width: '100%' }}>
            {
              publishType == 2?
               <YouTubeHoverPreview video={video} sx={{width: '100%'}} />
               :
               publishType == 1?
               <Box>Photos</Box>
               :
               <Box></Box>
            }
          </Box>
          
          {/* Video Title */}
          <Box sx={{margin: "10pt"}}>
            <Typography
              sx={{
                marginTop: 0.5,
                color: "#EDE9F7",
                fontSize: "1.1rem",
                fontWeight: "bold",
                textAlign: "center",
                fontFamily: "'Space Grotesk', sans-serif"
              }}
            >
              {title}
            </Typography>

            {/* Video Description */}
            <Typography
              sx={{
                color: "#EDE9F7",
                fontSize: "0.9rem",
                fontFamily: "arial",
                textAlign: "left",
                marginTop: 0.4,
                marginBottom: 0,
                marginLeft: 1,
                marginRight: 1
              }}
            >
              {description.length > 200 ? description.slice(0, 200) + "..." : description}
            </Typography>
          </Box>

          <Stack direction="row" spacing={1} margin="15px" marginLeft="30px">
            <Box
              onClick={(e) => {
                e.stopPropagation();
                if (api.session != null){
                  if (isFavorite){
                    api.DeletePublicationLike(publicationID);
                    setLikeCounts(likesCount-1);
                  }
                  else{
                    api.PostPublicationLike(publicationID);
                    setLikeCounts(likesCount+1);
                  }
                  setIsFavorite(!isFavorite);
                }
                else{
                  setShowLogin(true);
                }
              }}
              sx={{ cursor: 'pointer' }}
            >
              {isFavorite ? <FavoriteIcon sx={{ color: '#FF5C5C' }} /> : <FavoriteBorderIcon />}
              <Typography>{likesCount}</Typography>
            </Box>

            <Box
              onClick={(e) => {
                e.stopPropagation();
                navigate(`publication/${publicationID}`)
              }}
              sx={{ cursor: 'pointer' }}
            >
              <ModeCommentIcon />
              <Typography>{comments}</Typography>
            </Box>

            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ cursor: 'pointer' }}
            >
              <IconButton 
                onClick={handleMenuOpen}
                sx={{ 
                  color: 'inherit',
                  padding: 0,
                  '&:hover': {
                    backgroundColor: 'rgba(157,0,255,.08)'
                  }
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          </Stack>
        </Stack>
      </Box>

      {/* Menú contextual */}
      <Menu 
        anchorEl={anchorEl} 
        open={Boolean(anchorEl)} 
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            backgroundColor: '#1E1B2E',
            '& .MuiMenuItem-root': {
              color: '#EDE9F7',
              '&:hover': {
                backgroundColor: 'rgba(157,0,255,.08)'
              }
            }
          }
        }}
      >
        <MenuItem onClick={handleOpenReportDialog}>
          <ReportIcon sx={{ mr: 1 }} />
          Reportar publicación
        </MenuItem>
        <MenuItem onClick={handleCopyLink}>
          <ContentCopyIcon sx={{ mr: 1 }} />
          Copiar link del post
        </MenuItem>
      </Menu>

      {/* Dialog para reportar */}
      <Dialog 
        open={openDialog} 
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          sx: {
            backgroundColor: '#1E1B2E',
            color: '#EDE9F7'
          }
        }}
      >
        <DialogTitle>Reportar publicación</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            label="Motivo del reporte"
            variant="outlined"
            sx={{
              marginTop: 1,
              '& .MuiOutlinedInput-root': {
                color: '#EDE9F7',
                '& fieldset': {
                  borderColor: 'rgba(199,125,255,.4)'
                },
                '&:hover fieldset': {
                  borderColor: '#9D00FF'
                }
              },
              '& .MuiInputLabel-root': {
                color: '#A8A3B8'
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setOpenDialog(false);
              setReason("");
            }}
            sx={{ color: '#A8A3B8' }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleReport} 
            variant="contained" 
            sx={{ 
              backgroundColor: '#6A00CC',
              '&:hover': {
                backgroundColor: '#9D00FF'
              }
            }}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        ContentProps={{
          sx: {
            backgroundColor: '#1E1B2E',
            color: '#EDE9F7'
          }
        }}
      />
    </>
  );
};

export default VideoBox;